export const home    = '/דף_הבית';
export const login    = 'התחברות';
export const contact = '/צור_קשר';
export const about   = '/הסיפור_שלנו';
export const benefits   = '/כל_ההטבות';
export const noMatch = '/404';
export const supplier = '/ספק';
export const benefit = '/הטבה';
export const commerce = '/סחר';
export const supplier_join = '/הצטרפות_ספקים';
export const client_join = '/הצטרפות_עמיתים';
export const smart_wallet = '/הארנק_החכם';
export const order_smart_wallet = '/הזמנת_הארנק_החכם';
export const membership_check = '/בדיקת_זכאות';
export const favorites = '/מועדפים';
// OLD PERSONAL ZONE: To revert, change personal_zone back to '/אזור_אישי' and user_info to '/איזור_אישי_חדש'
// Then update header files to use routes.personal_zone instead of routes.user_info
export const personal_zone = '/אזור_אישי_ישן';
export const search_results = '/תוצאות_חיפוש';
export const coupon = '/קופון';
export const experts = '/מומחים';
export const payment = '/תשלום';
export const thanks = '/אישור_הזמנה';
export const category = '/קטגוריה';
export const survey = '/סקר';
export const landing_page = '/נחיתה';
export const mail_link = '/אישור_זכאות';
export const car_lead = '/ליד_רכבים';
export const magazine = '/מגזין';
export const smart_consumption = '/צרכנות_חכמה';
export const legal_advice = '/ייעוץ_משפטי';
export const barcode = '/ברקוד';
export const forum = '/פורום';
export const customer_join = '/הצטרפות_עמיתים';
export const landing_join_content_page = '/תוכן_הצטרפות'

export const search = '/הנחה_בחיוב'

export const selected_benefits = '/הטבות'

export const present_benefits = '/הטבות_מתנה'

export const presents_benefits_page = '/דף_הטבות_מתנה'

export const banners_page = '/עמוד_באנרים'

export const user_info = '/איזור_אישי'
export const user_info_routes = {
  personal_info: '/פרטים_אישיים',
  personal_info_edit: '/עריכת_פרטים_אישיים',
  coupons: '/הקופונים_שלי',
  savings: '/החיסכון_שלי',
  favorites: '/המועדפים_שלי',
  order_history: '/היסטוריית_הזמנות',
  membership_certificate: '/הנפקת_תעודת_חברות',
}

export const personal_zone_routes ={
  personal_details: '/פרטים_אישיים',
  payment_methods: '/אמצעי_תשלום',
  address: '/כתובות_למשלוח',
  my_orders: '/הזמנות_שלי',
};

export const legal_advice_routes = {
  new_question: '/פנייה',
  view_question: '/שאלה',
  search_results: '/תוצאות_חיפוש',
  preview: '/תצוגה_מקדימה',
};

export const forum_routes = {
  view_post: '/נושא',
};
